import { gql } from '@apollo/client';

export const RemoveUserRoles = gql`
  mutation RemoveUserRoles($email: String!, $roles: [String!]!) {
    removeTenantUserRoles(
      removeTenantUserRolesInput: { email: $email, roles: $roles }
    ) {
      user {
        id
        email
        roles
      }
      errors {
        ... on RequiresElevatedTokenError {
          code
          message
        }
      }
    }
  }
`;
